import { TFunction } from 'i18next';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _isFunction from 'lodash/isFunction';
import { Options } from 'react-select';
import { SelectOption } from './types';

export function getSelectValue(value: unknown, options: Options<SelectOption>) {
  let newValue;
  if (typeof value === 'string' && options.length) {
    newValue = options.find((option) => _get(option, 'value') === value) || {
      value,
    };
  }
  if (_has(value, 'value')) {
    newValue = options.find(
      (option) => _get(option, 'value') === _get(value, 'value'),
    );
  }
  return newValue || value;
}

export function getOptionLabel(
  option: SelectOption,
  t: TFunction<'translation', undefined>,
) {
  if (option?.labelKey) return t(option.labelKey);
  const label = _get(option, 'label');
  if (_isFunction(label)) {
    // @ts-ignore
    return `${label()}`;
  }
  return `${label}`;
}
